import { render, staticRenderFns } from "./LayoutSidebar.vue?vue&type=template&id=4bd10fc4&scoped=true&"
import script from "./LayoutSidebar.vue?vue&type=script&lang=ts&"
export * from "./LayoutSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutSidebar.vue?vue&type=style&index=0&id=4bd10fc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd10fc4",
  null
  
)

export default component.exports